import { cn } from '@/components/ui';
import { useSocketIOPresenceIsOnline } from '@/socketio/SocketIOService';

export const UserPresenceStateBadge = (props: {
  userId: string | number;
  hideOffline?: boolean;
  className?: string;
}) => {
  const { isOnline, isConnected } = useSocketIOPresenceIsOnline(props.userId);

  if (!isConnected) {
    return null;
  }

  if (props.hideOffline && !isOnline) {
    return null;
  }

  return (
    <span
      className={cn(
        'inline-block size-2 shrink-0 rounded-full',
        isOnline ? 'bg-positive' : 'bg-ink-subtle',
        props.className,
      )}
      title={isOnline ? 'Online' : 'Offline'}
    />
  );
};
